import { LegacyBlockTheme } from "@softr-io/blocks-sdk";
import { usePageContext } from "./PageContext";
import { useMemo } from "react";

interface Props {
    variant?: "tall" | "short";
}
export function BlockLoader({ variant = "tall" }: Props) {
    const { theme } = usePageContext();
    const style = useMemo(() => makeLoaderStylesheet(theme), [theme]);
    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: style }} />
            <div
                role="progressbar"
                style={{
                    display: "flex",
                    height: variant === "tall" ? "540px" : "60px",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <div className="spr-spinner" />
            </div>
        </>
    );
}

// Currently, softr-page-renderer is bundled as a single .js file with no way to import CSS files.
// In webpack, it's suggested to use MiniCssExtractPlugin to extract CSS files into a separate CSS file,
// which I don't want to do as a part of this ticket because it requires changes to Platform and Studio.
// I'll just use an inline stylesheet instead.
const makeLoaderStylesheet = (
    theme: Pick<LegacyBlockTheme, "defaultBodyTextColor" | "defaultButtonBackgroundColor" | "defaultBackgroundColor">,
) => `
.spr-spinner {
    width: 36px;
    height: 36px;
    border: 2px solid color-mix(in srgb, ${theme.defaultBodyTextColor} 30%, transparent 70%);
    border-bottom-color: ${theme.defaultButtonBackgroundColor};
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
`;
